module.exports = __webpack_public_path__ + "img/avatar-03-120x120.17047c91.png";